import React, { Component } from 'react';
import { FaArrowCircleUp } from 'react-icons/fa';

const scrollTop = () => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
};

class ScrollArrow extends Component {
  state = {
    showScroll: false,
  };

  checkScrollTop = () => {
    const { showScroll } = this.state;
    if (!showScroll && window.pageYOffset > 400) {
      this.setState({ showScroll: true });
    } else if (showScroll && window.pageYOffset <= 400) {
      this.setState({ showScroll: false });
    }
  };
  componentDidMount() {
    window.addEventListener('scroll', this.checkScrollTop);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.checkScrollTop);
  }

  render() {
    const { showScroll } = this.state;
    return (
      <FaArrowCircleUp
        className="scrollTop"
        onClick={scrollTop}
        style={{ height: 40, display: showScroll ? 'flex' : 'none' }}
      />
    );
  }
}

export default ScrollArrow;
